// extracted by mini-css-extract-plugin
export var container = "_55-0";
export var infoButton = "_55-1";
export var label = "_55-3";
export var labelExpanded = "_55-4";
export var price = "_55-5";
export var priceExpanded = "_55-6";
export var title = "_55-2";